"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Modal: true
};
exports.Modal = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _react = _interopRequireDefault(require("react"));
var _ModalBase = require("../../elements/modal-base/ModalBase");
var _Button = require("../../elements/button/Button");
var _Link = require("../../elements/link/Link");
var _close = require("../../assets/icons/close.svg");
var _modalModule = _interopRequireDefault(require("./modal.module.scss"));
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var _classnames = _interopRequireDefault(require("classnames"));
var _noop = require("../../utils/noop");
var _useModal = require("./useModal");
Object.keys(_useModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useModal[key];
    }
  });
});
var Modal = function Modal(_ref) {
  var _classNames;
  var isOpen = _ref.isOpen,
    className = _ref.className,
    _ref$close = _ref.close,
    close = _ref$close === void 0 ? _noop.noop : _ref$close,
    title = _ref.title,
    children = _ref.children,
    disabled = _ref.disabled,
    primaryButtonText = _ref.primaryButtonText,
    onPrimaryButtonClick = _ref.onPrimaryButtonClick,
    secondaryButtonText = _ref.secondaryButtonText,
    onSecondaryButtonClick = _ref.onSecondaryButtonClick,
    linkText = _ref.linkText,
    linkHref = _ref.linkHref,
    destructiveButtonText = _ref.destructiveButtonText,
    onDestructiveButtonClick = _ref.onDestructiveButtonClick,
    afterClose = _ref.afterClose,
    _ref$withoutPadding = _ref.withoutPadding,
    withoutPadding = _ref$withoutPadding === void 0 ? false : _ref$withoutPadding,
    _ref$withoutOverflow = _ref.withoutOverflow,
    withoutOverflow = _ref$withoutOverflow === void 0 ? false : _ref$withoutOverflow,
    _ref$closable = _ref.closable,
    closable = _ref$closable === void 0 ? true : _ref$closable;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_ModalBase.ModalBase, {
    isOpen: isOpen,
    close: close,
    afterClose: afterClose,
    className: className,
    closable: closable
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _modalModule.default['modal__header']
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: _modalModule.default['modal__title']
  }, title), closable && /*#__PURE__*/_react.default.createElement(_close.ReactComponent, {
    "data-testid": "close-icon",
    onClick: close,
    className: _modalModule.default['modal__close-icon']
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "modal-body",
    className: (0, _classnames.default)(_modalModule.default['modal__body'], (_classNames = {}, (0, _defineProperty2.default)(_classNames, _modalModule.default['modal__body--without-padding'], withoutPadding), (0, _defineProperty2.default)(_classNames, _modalModule.default['modal__body--without-overflow'], withoutOverflow), _classNames))
  }, children), /*#__PURE__*/_react.default.createElement("div", {
    className: _modalModule.default['modal__footer']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _modalModule.default['modal__action-buttons']
  }, /*#__PURE__*/_react.default.createElement(_Button.PrimaryButton, {
    disabled: disabled,
    onClick: onPrimaryButtonClick
  }, primaryButtonText || t('common.ok')), secondaryButtonText && /*#__PURE__*/_react.default.createElement(_Button.NeutralButton, {
    disabled: disabled,
    onClick: onSecondaryButtonClick
  }, secondaryButtonText), linkText && linkHref && /*#__PURE__*/_react.default.createElement(_Link.Link, {
    href: linkHref
  }, linkText)), destructiveButtonText && /*#__PURE__*/_react.default.createElement(_Button.DestructiveButton, {
    disabled: disabled,
    onClick: onDestructiveButtonClick,
    className: _modalModule.default['modal__destructive-button']
  }, destructiveButtonText)));
};
exports.Modal = Modal;